import createLucideIcon from '../createLucideIcon';

const ChevronDown = createLucideIcon('ChevronDownIcon', [
  ['path', { d: 'm6 9 6 6 6-6', key: 'qrunsl' }],
]);

export default ChevronDown;
